import React, { useState } from "react";
import Navbar from "./components/Navbar";
import CarouselSection from "./components/CarouselSection";
import Footer from "./components/Footer";
import EnquiryModal from "./components/EnquiryModal";
import ProjectsPage from "./pages/ProjectsPage";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

function HomePage() {
  const [showEnquiry, setShowEnquiry] = useState(false);

  const indoorProducts = [
    {
      image: require("./assets/indoor1.jpg"),
      title: "Chandelier",
    },
    {
      image: require("./assets/indoor2.jpg"),
      title: "Ceiling Light",
    },
    {
      image: require("./assets/indoor3.jpg"),
      title: "Wall Lamp",
    },
    {
      image: require("./assets/indoor4.jpg"),
      title: "Pendant Light",
    },
  ];

  const outdoorProducts = [
    {
      image: require("./assets/outdoor1.jpg"),
      title: "Garden Light",
    },
    {
      image: require("./assets/outdoor2.jpg"),
      title: "Street Light",
    },
    {
      image: require("./assets/outdoor3.jpg"),
      title: "Pathway Light",
    },
    {
      image: require("./assets/outdoor4.jpg"),
      title: "Facade Lighting",
    },
  ];

  const projects = [
    {
      image: require("./assets/project1.jpg"),
      title: "Mall Lighting",
    },
    {
      image: require("./assets/project2.jpg"),
      title: "Hotel Lighting",
    },
    {
      image: require("./assets/project3.jpg"),
      title: "Outdoor Landscape",
    },
    {
      image: require("./assets/project4.jpg"),
      title: "Building Facade",
    },
  ];

  const clientLogos = [
    "brandlogo0.jpg",
    "brandlogo1.jpg",
    "brandlogo2.png",
    "brandlogo3.png",
    "brandlogo4.png",
    "brandlogo5.png",
    "brandlogo6.png",
    "brandlogo7.png",
    "brandlogo8.jpg",
    "brandlogo9.png",
    "brandlogo10.png",
    "brandlogo11.png",
    "brandlogo12.png",
    "brandlogo13.png",
    "brandlogo14.png",
    "brandlogo15.png",
        "brandlogo15.png",
        "brandlogo16.png",
  ];

  return (
    <div className="App">
      <Navbar openEnquiry={() => setShowEnquiry(true)} />

      <CarouselSection />

      {/* Indoor Lighting */}
      <section id="indoor-lighting" className="section-light">
        <div className="container">
          <h2 className="section-title">Indoor Lighting</h2>
          <div className="section-underline"></div>

          <p className="section-description">
            Explore a range of beautiful indoor lighting solutions that blend
            functionality, elegance and timeless design.
          </p>

          <div className="row">
            {indoorProducts.map((item, index) => (
              <div className="col-lg-3 col-md-6 mb-4" key={index}>
                <div className="lighting-card">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="lighting-image"
                  />

                  <div className="lighting-content">
                    <h5>{item.title}</h5>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Outdoor Lighting */}
      <section id="outdoor-lighting" className="section-white">
        <div className="container">
          <h2 className="section-title">Outdoor Lighting</h2>
          <div className="section-underline"></div>

          <p className="section-description">
            Premium outdoor lighting solutions crafted to elevate landscapes,
            architecture and open spaces.
          </p>

          <div className="row">
            {outdoorProducts.map((item, index) => (
              <div className="col-lg-3 col-md-6 mb-4" key={index}>
                <div className="lighting-card">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="lighting-image"
                  />

                  <div className="lighting-content">
                    <h5>{item.title}</h5>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
            {/* Projects */}
      <section id="projects" className="section-light">
        <div className="container">
          <h2 className="section-title">Our Projects</h2>
          <div className="section-underline"></div>

          <p className="section-description">
            Delivering innovative lighting solutions for hospitality,
            commercial, retail and residential environments.
          </p>

          <div className="row">
            {projects.map((project, index) => (
              <div className="col-lg-3 col-md-6 mb-4" key={index}>
                <div className="project-card">
                  <img
                    src={project.image}
                    alt={project.title}
                    className="project-image"
                  />

                  <div className="project-overlay">
                    <h5>{project.title}</h5>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Statistics */}
      <section className="stats-section">
        <div className="container">
          <div className="row text-center">

            <div className="col-md-4 mb-4">
              <h2>500+</h2>
              <p>Projects Completed</p>
            </div>

            <div className="col-md-4 mb-4">
              <h2>100+</h2>
              <p>Prestigious Clients</p>
            </div>

            <div className="col-md-4 mb-4">
              <h2>10+</h2>
              <p>Years of Excellence</p>
            </div>

          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="section-white">
        <div className="container">
          <h2 className="section-title">
            Why Choose Kashi Lighting
          </h2>

          <div className="section-underline"></div>

          <p className="section-description">
            We combine creativity, technical expertise and premium
            products to deliver exceptional lighting experiences for
            hospitality, commercial and residential projects.
          </p>

          <div className="row">

            <div className="col-lg-4 col-md-6 mb-4">
              <div className="why-card">
                <div className="why-icon">💡</div>
                <h5>Custom Lighting Design</h5>
                <p>
                  Tailored lighting concepts designed around
                  your project requirements.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 mb-4">
              <div className="why-card">
                <div className="why-icon">⭐</div>
                <h5>Premium Products</h5>
                <p>
                  Carefully selected lighting products that
                  combine aesthetics and durability.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 mb-4">
              <div className="why-card">
                <div className="why-icon">🏢</div>
                <h5>Commercial Expertise</h5>
                <p>
                  Extensive experience across hospitality,
                  retail and corporate projects.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 mb-4">
              <div className="why-card">
                <div className="why-icon">🎯</div>
                <h5>End-to-End Consultancy</h5>
                <p>
                  From planning to execution, we support every
                  stage of your lighting journey.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 mb-4">
              <div className="why-card">
                <div className="why-icon">⏱️</div>
                <h5>Timely Delivery</h5>
                <p>
                  Efficient project management with commitment
                  to deadlines.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 mb-4">
              <div className="why-card">
                <div className="why-icon">🌏</div>
                <h5>Pan India Support</h5>
                <p>
                  Delivering lighting solutions and consultancy
                  services across India.
                </p>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Clients */}
      <section id="clients" className="section-white">
        <div className="container">
          <h2 className="section-title">Our Clients</h2>
          <div className="section-underline"></div>

          <p className="section-description">
            Trusted by leading brands, hospitality groups and
            renowned organisations across India.
          </p>

          <div className="row justify-content-center">
            {clientLogos.map((logo, index) => (
              <div
                className="col-lg-3 col-md-4 col-6 mb-4"
                key={index}
              >
                <div className="client-card">
                  <img
                    src={require(`./assets/${logo}`)}
                    alt={`Client ${index + 1}`}
                    className="client-logo"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
            {/* About */}
      <section id="about" className="section-light">
        <div className="container">
          <h2 className="section-title">About Us</h2>
          <div className="section-underline"></div>

          <div className="about-box">
            <p>
              Kashi Lighting Design and Consultancy is a Mumbai-based lighting
              solutions company delivering thoughtfully designed indoor,
              outdoor, hospitality and commercial lighting experiences.
            </p>

            <p>
              Our approach combines creativity, technical expertise and premium
              products to create spaces that are functional, elegant and
              visually inspiring.
            </p>

            <p>
              From restaurants and retail spaces to corporate offices and luxury
              developments, we work closely with architects, designers and
              businesses to provide lighting solutions tailored to every
              project.
            </p>
          </div>
        </div>
      </section>

      {/* Contact */}
      <section id="contact" className="section-white">
        <div className="container">
          <h2 className="section-title">Contact Us</h2>
          <div className="section-underline"></div>

          <div className="contact-card">
            <h4>Kashi Lighting Design and Consultancy</h4>

            <p>
              📍 Nesco, WeWork
              <br />
              Goregaon East
              <br />
              Mumbai, Maharashtra
            </p>

            <p>
              <strong>Phone:</strong> +91 98697 95151
            </p>

            <p>
              <strong>Email:</strong> info@kashilighting.com
            </p>

            <p>
              <strong>Working Hours:</strong>
              <br />
              Monday - Saturday | 9:00 AM - 6:30 PM
            </p>

            <button
              className="view-all-btn"
              onClick={() => setShowEnquiry(true)}
            >
              Send Enquiry
            </button>
          </div>
        </div>
      </section>

      {/* Enquiry Modal */}
      {showEnquiry && (
        <EnquiryModal
          isOpen={showEnquiry}
          onClose={() => setShowEnquiry(false)}
        />
      )}

      {/* Footer */}
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/projects" element={<ProjectsPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;